__turbopack_context__.v({
  "row": "CommandRegistryHelpDialogRow-module__cJcWvW__row",
  "rowInteractive": "CommandRegistryHelpDialogRow-module__cJcWvW__rowInteractive",
  "rowInteractiveHovered": "CommandRegistryHelpDialogRow-module__cJcWvW__rowInteractiveHovered",
  "shortcutKeys": "CommandRegistryHelpDialogRow-module__cJcWvW__shortcutKeys",
});
